/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createScrapeJobDetailsDataSchema = z.object({
	organisationId: z.string().uuid(),
	url: z.string().url(),
	campaignId: z.string().uuid(),
	brandingId: z.string().uuid(),
	generateKeyImage: z.boolean().nullable().optional(),
})

export type CreateScrapeJobDetailsDataSchema = z.infer<typeof createScrapeJobDetailsDataSchema>
